app.service('order', function (front, orderConfig, cartStepAnalytics, basketView, broker, loginView, deliveryView, previewOrder,
	paymentView, deliveryTimeView, finalizeView, changePasswordView, loginModal, operatorClientView, deliveryBadge, ajaxOrder,
	giftCardOrderSelectionView, giftCardClientDataView, giftCardPaymentView, passwordRecovery,
	obligatoryChangePassword, MOP, orderPath, guestKmeLogin, permissionModal, orderClass) {
	var config;

	function run() {
		config = orderConfig.getData();
		orderClass.init();
		loginModal.init();
		switch (front.page()) {
			case 'guest-kme-login':
				guestKmeLogin.init();
				break;
			case 'basket':
				basketView.init();
				break;
			case 'login':
				loginView.init();
				break;
			case 'operator-client':
				operatorClientView.init();
				break;
			case 'home-delivery':
				deliveryView.init();
				break;
			case 'shop-delivery':
				deliveryView.init();
				break;
			case 'inpost-delivery':
				deliveryView.init();
				break;
			case 'mail-delivery':
				deliveryView.init();
				break;
			case 'gift-card-client-data':
				giftCardClientDataView.init();
				break;
			case 'payment':
				paymentView.init();
				break;
			case 'gift-card-payment':
				giftCardPaymentView.init();
				break;
			case 'order-payment-module':
			case 'account-payment-module':
			case 'gift-card-order-payment-module':
				MOP.init();
				break;
			case 'delivery-time':
				deliveryTimeView.init();
				break;
			case 'finalize':
				finalizeView.init();
				break;
			case 'password-reminder':
				changePasswordView.init();
				break;
			case 'obligatory-change-password':
				obligatoryChangePassword.init();
				break;
			case 'gift-card-order-selection':
				giftCardOrderSelectionView.init();
				break;
			default:
				break;
		}
		if (typeof config.cartStepOrderInfo !== 'undefined') {

			if (config.cartStepOrderInfo.paymentType && config.cartStepOrderInfo.paymentType.length > 0) {
				UA.push({
					'TYP_payment_F01': config.cartStepOrderInfo.paymentType,
					'TYP_payment_F02': config.cartStepOrderInfo.userTypeCompany,
					'event': 'PaymentMethod'
				});
			}
			if (config.cartStepOrderInfo.deliveryType && config.cartStepOrderInfo.deliveryType.length > 0) {
				UA.push({
					'TYP_delivery_F01': config.cartStepOrderInfo.deliveryType,
					'event': 'DeliveryMethod'
				});
			}
		}
		cartStepAnalytics.logEvent();
	}

	let isOneInit = false;
	function init() {
		ajaxOrder.init();
		previewOrder.init();
		orderPath.init();
		deliveryBadge.init();
		passwordRecovery.init();
		permissionModal.init();
		run();
		if (!isOneInit) {
			isOneInit = true;
			broker.on('PAGE_CHANGE', function () {
				run();
			});
		}
	}

	return {
		init
	};
});
